export default {
    TODAY: "today",
    FROM: "common.from",
    TO: "common.to",
    CANCEL: "common.cancel",
    OK: "common.ok"
};
